import { patientAnalyticAction } from "../actions/patientAnalayticAction";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accountFilter: "",
  startDate: "",
  endDate: "",
};

const patientAnalyticSlice = createSlice({
  name: "patientAnalytic",
  initialState: initialState,
  reducers: patientAnalyticAction,
});

export const { changeFilter } = patientAnalyticSlice.actions;

export default patientAnalyticSlice.reducer;
